import { jsx as t } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import R from "../../../../internal/Typography/Typography.js";
import { TypographyElement as N, TypographyVariant as P } from "../../../../internal/Typography/types.js";
import T from "../../../../internal/Button/Button.js";
import { ButtonVariant as k } from "../../../../internal/Button/types.js";
import E from "../../../../../core/Context/useCoreContext.js";
import { useMemo as p, useState as D, useCallback as c, useEffect as q } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import "../../../../../external/preact/compat/dist/compat.module.js";
import b from "../../../../../hooks/useMutation/useMutation.js";
/* empty css                           */
import { getExpectedRepaymentDate as w, getPaymentRatePercentage as j, debounce as G } from "../utils/utils.js";
import { CapitalErrorMessageDisplay as X } from "../utils/CapitalErrorMessageDisplay.js";
import { calculateSliderAdjustedMidValue as H } from "../../../../internal/Slider/Slider.js";
import { CAPITAL_REPAYMENT_FREQUENCY as Q } from "../../../../constants.js";
import { Fragment as U } from "../../../../../external/preact/dist/preact.module.js";
import W from "../../../../internal/CapitalSlider/CapitalSlider.js";
import $ from "../../../../internal/InfoBox/InfoBox.js";
import z from "../../../../internal/StructuredList/StructuredList.js";
import { useConfigContext as J } from "../../../../../core/ConfigContext/context.js";
const K = () => /* @__PURE__ */ t("div", { className: "adyen-pe-capital-offer-selection__loading-container", children: [...Array(4)].map((e, r) => /* @__PURE__ */ t("div", { className: "adyen-pe-capital-offer-selection__loading-skeleton" }, r)) }), Z = ({ data: e }) => {
  const { i18n: r } = E(), i = p(() => {
    const n = e.expectedRepaymentPeriodDays && w(e.expectedRepaymentPeriodDays);
    return n ? r.date(n, { month: "long" }) : null;
  }, [e, r]);
  return /* @__PURE__ */ t("div", { className: "adyen-pe-capital-offer-selection__information", children: [
    /* @__PURE__ */ t(R, { el: N.SPAN, variant: P.BODY, wide: !0, children: i && r.get("capital.youWillNeedToRepayAMinimumOfXEveryXDaysToPayOffTheFunds", {
      values: {
        amount: r.amount(e.thresholdAmount.value, e.thresholdAmount.currency),
        days: Q,
        date: i
      }
    }) }),
    /* @__PURE__ */ t(
      z,
      {
        renderValue: (n) => /* @__PURE__ */ t(R, { el: N.SPAN, stronger: !0, variant: P.CAPTION, children: n }),
        renderLabel: (n) => /* @__PURE__ */ t(R, { el: N.SPAN, variant: P.CAPTION, children: n }),
        items: [
          { key: "capital.fees", value: r.amount(e.feesAmount.value, e.feesAmount.currency) },
          {
            key: "capital.dailyRepaymentRate",
            value: `${r.get("capital.xPercent", {
              values: { percentage: j(e.repaymentRate) }
            })}`
          },
          {
            key: "capital.expectedRepaymentPeriod",
            value: r.get("capital.xDays", { values: { days: e.expectedRepaymentPeriodDays } })
          }
        ]
      }
    )
  ] });
}, he = ({
  dynamicOffersConfig: e,
  dynamicOffersConfigError: r,
  emptyGrantOffer: i,
  onContactSupport: n,
  onOfferDismiss: d,
  onOfferSelect: M,
  requestedAmount: m
}) => {
  const { i18n: x } = E(), v = p(() => {
    if (e)
      return H(
        e.minAmount.value,
        e.maxAmount.value,
        e.step
      );
  }, [e]), [u, S] = D(void 0), s = p(() => e == null ? void 0 : e.minAmount.currency, [e == null ? void 0 : e.minAmount.currency]), { createGrantOffer: V, getDynamicGrantOffer: I } = J().endpoints, a = b({
    queryFn: I,
    options: {
      retry: 1,
      shouldRetry: c((o) => o.status === 500, []),
      onSettled: c(() => {
        _(!1);
      }, [])
    }
  }), l = b({
    queryFn: V,
    options: {
      onSuccess: (o) => M(o)
    }
  }), B = c(() => {
    var o, L;
    l.mutate({
      body: {
        amount: ((o = a.data) == null ? void 0 : o.grantAmount.value) || u,
        currency: ((L = a.data) == null ? void 0 : L.grantAmount.currency) || s
      },
      contentType: "application/json"
    });
  }, [s, a.data, u, l]), y = c(
    (o) => a.mutate({}, { query: { amount: o, currency: s } }),
    [s, a]
  ), [h, _] = D(!1), A = G(y, 300), F = c(
    (o) => {
      A.cancel(), _(!0), S(o);
    },
    [A]
  ), Y = (o) => A(o);
  q(() => {
    e && !a.data && !u && (S(
      (o) => o || (m ? Number(m) : v || e.minAmount.value)
    ), y(u || v || e.minAmount.value));
  }, [e, a.data, y, v, m, u]);
  const g = p(
    () => l.isLoading || a.isLoading || h,
    [a.isLoading, h, l.isLoading]
  );
  return /* @__PURE__ */ t("div", { className: "adyen-pe-capital-offer-selection", children: l.error || a.error || i || r ? /* @__PURE__ */ t(
    X,
    {
      error: l.error || a.error || r,
      onBack: d,
      onContactSupport: n,
      emptyGrantOffer: i
    }
  ) : /* @__PURE__ */ t(U, { children: [
    e && /* @__PURE__ */ t(
      W,
      {
        value: u,
        dynamicOffersConfig: e,
        onValueChange: F,
        onRelease: Y
      }
    ),
    /* @__PURE__ */ t($, { className: "adyen-pe-capital-offer-selection__details", children: !a.data || a.isLoading || h ? /* @__PURE__ */ t(K, {}) : a.data ? /* @__PURE__ */ t(Z, { data: a.data }) : null }),
    /* @__PURE__ */ t("div", { className: "adyen-pe-capital-offer-selection__buttons", children: [
      d && /* @__PURE__ */ t(T, { variant: k.SECONDARY, onClick: d, children: x.get("back") }),
      /* @__PURE__ */ t(
        T,
        {
          variant: k.PRIMARY,
          state: g ? "loading" : void 0,
          onClick: B,
          disabled: l.isLoading || !(e != null && e.minAmount),
          children: x.get(g ? "loading" : "capital.reviewOffer")
        }
      )
    ] })
  ] }) });
};
export {
  he as CapitalOfferSelection
};
